/*  Cms-driven legal page renderer.
    ────────────────────────────────────────────────────────────────
    iter100.147 — Reads three CMS keys from a legal page slug
    (`legal_privacy`, `legal_terms`, `legal_refund`):
        title       — H1
        updated_at  — "Last updated" line
        body_html   — the full policy body as sanitised HTML.

    The admin CMS body_html field is a plain textarea that stores raw
    HTML — we trust it because only admins can edit it. If untrusted
    editors ever get access, wrap the render in DOMPurify.
*/
import React from "react";
import LegalLayout from "./LegalLayout";
import { useCms } from "@/lib/useCms";


export default function CmsLegalPage({ page, fallbackTitle, fallbackUpdated, fallbackBody }) {
    const { t, loading } = useCms(page);

    const title    = t("title", fallbackTitle || "");
    const updated  = t("updated_at", fallbackUpdated || "");
    const bodyHtml = t("body_html", fallbackBody || "");

    return (
        <LegalLayout title={title || fallbackTitle} updated={updated || fallbackUpdated}>
            {loading ? (
                <div className="text-sm text-muted-foreground py-8" data-testid="legal-loading">
                    Loading the latest policy…
                </div>
            ) : (
                <div
                    data-testid={`legal-body-${page}`}
                    dangerouslySetInnerHTML={{ __html: bodyHtml || fallbackBody || "" }}
                />
            )}
        </LegalLayout>
    );
}
